import APICall from "../utils/APICall";

export default class DiscountHubService {
  // Referral Codes
  static createReferralCode = async (payload) => {
    return await APICall("/api/DiscountHub/create-referral-code", "POST", payload);
  };

  static updateReferralCode = async (payload) => {
    return await APICall("/api/DiscountHub/update-referral-code", "PATCH", payload);
  };

  static deactivateReferralCode = async (id) => {
    return await APICall(`/api/DiscountHub/deactivate-referral-code/${id}`, "POST");
  };

  static listReferralCodes = async (page, pageLimit, search, startDate, endDate, includeInactive) => {
    let url = `/api/DiscountHub/list-referral-codes?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    if (startDate) url = `${url}&startDate=${startDate}`;
    if (endDate) url = `${url}&endDate=${endDate}`;
    if (includeInactive !== undefined && includeInactive !== null) {
      url = `${url}&includeInactive=${includeInactive}`;
    }
    return await APICall(url, "GET");
  };

  static getReferralCodeDetails = async (id) => {
    return await APICall(`/api/DiscountHub/referral-code-details?id=${id}`, "GET");
  };

  static bulkCreateReferralCodes = async (referralCodes) => {
    return await APICall("/api/DiscountHub/bulk-create-referral-codes", "POST", {
      referralCodes,
    });
  };

  static exportReferralCodes = async (search, startDate, endDate, includeInactive) => {
    let url = `/api/DiscountHub/export-referral-codes`;
    const params = [];
    if (search) params.push(`search=${search}`);
    if (startDate) params.push(`startDate=${startDate}`);
    if (endDate) params.push(`endDate=${endDate}`);
    if (includeInactive !== undefined && includeInactive !== null) {
      params.push(`includeInactive=${includeInactive}`);
    }
    if (params.length > 0) {
      url = `${url}?${params.join("&")}`;
    }
    return await APICall(url, "GET");
  };

  // Staff Referral Codes
  static createStaffReferralCode = async (payload) => {
    return await APICall("/api/DiscountHub/create-staff-referral-code", "POST", payload);
  };

  static updateStaffReferralCode = async (payload) => {
    return await APICall("/api/DiscountHub/update-staff-referral-code", "PATCH", payload);
  };

  static deactivateStaffReferralCode = async (id) => {
    return await APICall(`/api/DiscountHub/deactivate-staff-referral-code/${id}`, "POST");
  };

  static listStaffReferralCodes = async (page, pageLimit, search, startDate, endDate, includeInactive) => {
    let url = `/api/DiscountHub/list-staff-referral-codes?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    if (startDate) url = `${url}&startDate=${startDate}`;
    if (endDate) url = `${url}&endDate=${endDate}`;
    if (includeInactive !== undefined && includeInactive !== null) {
      url = `${url}&includeInactive=${includeInactive}`;
    }
    return await APICall(url, "GET");
  };

  static getStaffReferralCodeDetails = async (id) => {
    return await APICall(`/api/DiscountHub/staff-referral-code/${id}`, "GET");
  };

  static bulkCreateStaffReferralCodes = async (staffReferralCodes) => {
    return await APICall(
      "/api/DiscountHub/bulk-create-staff-referral-codes",
      "POST",
      { staffReferralCodes }
    );
  };

  static exportStaffReferralCodes = async (search, startDate, endDate, includeInactive) => {
    let url = `/api/DiscountHub/export-staff-referral-codes`;
    const params = [];
    if (search) params.push(`search=${search}`);
    if (startDate) params.push(`startDate=${startDate}`);
    if (endDate) params.push(`endDate=${endDate}`);
    if (includeInactive !== undefined && includeInactive !== null) {
      params.push(`includeInactive=${includeInactive}`);
    }
    if (params.length > 0) {
      url = `${url}?${params.join("&")}`;
    }
    return await APICall(url, "GET");
  };
}
